import React, { memo } from "react"
import CenteredContainer from "../CenteredContainer"
import LoadingIndicator from "../LoadingIndicator"

function LoadingScreen() {
  return (
    <CenteredContainer>
      <LoadingIndicator />
    </CenteredContainer>
  )
}

export default memo(LoadingScreen)
